// src/hooks/useCoachName.js
import { useCallback, useEffect, useState } from 'react';
import { usersAPI } from '../services/api';

const LS_KEY = 'coachName';

function readCoachNameFromLocalStorage() {
  try {
    const cached = localStorage.getItem(LS_KEY);
    if (cached) return cached;
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      return (
        user?.coachName ||
        user?.coach?.coachName ||
        user?.username ||
        user?.email ||
        ''
      );
    }
  } catch {}
  return '';
}

/**
 * Fetches coachName from /users/me and caches it in localStorage.
 * Returns { coachName, loading, error, refresh }.
 */
export default function useCoachName(options = {}) {
  const { immediate = true } = options;
  const [coachName, setCoachName] = useState(() => readCoachNameFromLocalStorage());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const saveLocal = (name) => {
    try { localStorage.setItem(LS_KEY, name || ''); } catch {}
  };

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await usersAPI.getMyProfile();
  const data = res?.data || {};
  const name = data.coachName || data.coach?.coachName || data.username || data.email || readCoachNameFromLocalStorage();
      setCoachName(name);
      saveLocal(name);
      return name;
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!immediate) return;
    // If no cached value, or empty, fetch fresh
    if (!coachName) {
      refresh().catch(() => {});
    } else {
      // Optionally still refresh in background
      refresh().catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [immediate]);

  return { coachName, loading, error, refresh };
}
